import { TABLE_COLUMN_WIDTH } from '../../../components/ModelCompareV4/constants.mjs';
import { highCapacityAggregation } from './products/highCapacityAggregation.mjs';
import { missionCritical } from './products/missionCritical.mjs';
import { professional24 } from './products/professional24.mjs';
import { professional24PoE } from './products/professional24PoE.mjs';
import { professional48 } from './products/professional48.mjs';
import { professional48PoE } from './products/professional48PoE.mjs';
import { professionalHd24 } from './products/professionalHd24.mjs';
import { professionalHd24Poe } from './products/professionalHd24Poe.mjs';
import { professionalMax16 } from './products/professionalMax16.mjs';
import { professionalMax16PoE } from './products/professionalMax16PoE.mjs';
import { professionalMax24 } from './products/professionalMax24.mjs';
import { professionalMax24PoE } from './products/professionalMax24PoE.mjs';
import { professionalMax48 } from './products/professionalMax48.mjs';
import { professionalMax48PoE } from './products/professionalMax48PoE.mjs';
import { professionalXg10PoE } from './products/professionalXg10PoE.mjs';
import { professionalXg24PoE } from './products/professionalXg24PoE.mjs';
import { professionalXg48PoE } from './products/professionalXg48PoE.mjs';
import { proXgAggregation } from './products/proXgAggregation.mjs';
import './properties/index.mjs';
import { generalRedundancy } from './properties/generalRedundancy.mjs';
import { dimensions } from './properties/dimensions.mjs';
import { portCount } from './properties/portCount.mjs';
import { downlinkSpeed } from './properties/downlinkSpeed.mjs';
import { uplinkSpeed } from './properties/uplinkSpeed.mjs';
import { poeOutput } from './properties/poeOutput.mjs';
import { poeAvailability } from './properties/poeAvailability.mjs';
import { etherlighting } from './properties/etherlighting.mjs';
import { proAvSupport } from './properties/proAvSupport.mjs';
import { mounting } from './properties/mounting.mjs';
"use strict";
const SwitchingProfessional = {
  properties: [dimensions, portCount, downlinkSpeed, uplinkSpeed, poeOutput, poeAvailability, etherlighting, proAvSupport, mounting, generalRedundancy],
  products: [proXgAggregation,
  // Pro XG SubList
  professionalXg48PoE, professionalXg24PoE, professionalXg10PoE,
  // Pro HD SubList
  professionalHd24Poe, professionalHd24,
  // spencer order request
  highCapacityAggregation,
  // Pro Max SubList
  professionalMax48PoE, professionalMax24PoE, professionalMax16PoE, professionalMax48, professionalMax24, professionalMax16,
  // Professional SubList
  professional48PoE, professional24PoE, professional48, professional24, missionCritical],
  columnWidth: TABLE_COLUMN_WIDTH,
  showBadges: true
};
export { SwitchingProfessional };
//# sourceMappingURL=SwitchingProfessional.mjs.map
